import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserSessionPingResponse } from 'core/models';
import { ApiBaseService } from './api.base.service';

@Injectable({
    providedIn: 'root',
})
export class ApiUserSessionService extends ApiBaseService {
    constructor(http: HttpClient) {
        super(http, '/User/');
    }

    public ping(): Observable<UserSessionPingResponse> {
        return this.post<UserSessionPingResponse>('Session/Ping', null);
    }

    public logout(): Observable<boolean> {
        return this.post<boolean>('Logout', null);
    }
}
